// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Case, CaseT, verifyCase } from "./case";
import { Emit } from "./emit";
import { Otherwise } from "./otherwise";

/**
 * An enumerated value selects one member of a set of templates.
 */
export class EnumMapRule implements flatbuffers.IUnpackableObject<EnumMapRuleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EnumMapRule {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEnumMapRule(bb: flatbuffers.ByteBuffer, obj?: EnumMapRule): EnumMapRule {
    return (obj || new EnumMapRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsEnumMapRule(
    bb: flatbuffers.ByteBuffer,
    obj?: EnumMapRule,
  ): EnumMapRule {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EnumMapRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  set(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
  }

  setLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  setArray(): Uint32Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return new Uint32Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  cases(index: number, obj?: Case): Case | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Case()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  casesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  otherwise(): Otherwise {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Otherwise.Error;
  }

  otherwiseMember(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  emit(): Emit {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Emit.WholeSet;
  }

  static startEnumMapRule(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addSet(builder: flatbuffers.Builder, setOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, setOffset, 0);
  }

  static createSetVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint32Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createSetVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createSetVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint32Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt32(data[i]!);
    }
    return builder.endVector();
  }

  static startSetVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addCases(builder: flatbuffers.Builder, casesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, casesOffset, 0);
  }

  static createCasesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startCasesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addOtherwise(builder: flatbuffers.Builder, otherwise: Otherwise) {
    builder.addFieldInt8(2, otherwise, Otherwise.Error);
  }

  static addOtherwiseMember(builder: flatbuffers.Builder, otherwiseMember: number) {
    builder.addFieldInt16(3, otherwiseMember, 0);
  }

  static addEmit(builder: flatbuffers.Builder, emit: Emit) {
    builder.addFieldInt8(4, emit, Emit.WholeSet);
  }

  static endEnumMapRule(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // set
    builder.requiredField(offset, 6); // cases
    return offset;
  }

  static createEnumMapRule(
    builder: flatbuffers.Builder,
    setOffset: flatbuffers.Offset,
    casesOffset: flatbuffers.Offset,
    otherwise: Otherwise,
    otherwiseMember: number,
    emit: Emit,
  ): flatbuffers.Offset {
    EnumMapRule.startEnumMapRule(builder);
    EnumMapRule.addSet(builder, setOffset);
    EnumMapRule.addCases(builder, casesOffset);
    EnumMapRule.addOtherwise(builder, otherwise);
    EnumMapRule.addOtherwiseMember(builder, otherwiseMember);
    EnumMapRule.addEmit(builder, emit);
    return EnumMapRule.endEnumMapRule(builder);
  }

  unpack(): EnumMapRuleT {
    return new EnumMapRuleT(
      this.bb!.createScalarList<number>(this.set.bind(this), this.setLength()),
      this.bb!.createObjList<Case, CaseT>(this.cases.bind(this), this.casesLength()),
      this.otherwise(),
      this.otherwiseMember(),
      this.emit(),
    );
  }

  unpackTo(_o: EnumMapRuleT): void {
    _o.set = this.bb!.createScalarList<number>(this.set.bind(this), this.setLength());
    _o.cases = this.bb!.createObjList<Case, CaseT>(this.cases.bind(this), this.casesLength());
    _o.otherwise = this.otherwise();
    _o.otherwiseMember = this.otherwiseMember();
    _o.emit = this.emit();
  }

  unpackFields(...fields: string[]): EnumMapRuleT {
    const t = new EnumMapRuleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("set")) {
      t.set = this.bb!.createScalarList<number>(this.set.bind(this), this.setLength());
    }
    if (fieldSet.has("cases")) {
      t.cases = this.bb!.createObjList<Case, CaseT>(this.cases.bind(this), this.casesLength());
    }
    if (fieldSet.has("otherwise")) {
      t.otherwise = this.otherwise();
    }
    if (fieldSet.has("otherwise_member")) {
      t.otherwiseMember = this.otherwiseMember();
    }
    if (fieldSet.has("emit")) {
      t.emit = this.emit();
    }
    return t;
  }
}

export class EnumMapRuleT implements flatbuffers.IGeneratedObject {
  constructor(
    public set: number[] = [],
    public cases: CaseT[] = [],
    public otherwise: Otherwise = Otherwise.Error,
    public otherwiseMember: number = 0,
    public emit: Emit = Emit.WholeSet,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.set === null || this.set === undefined) {
      throw new Error('Required field "set" is not set');
    }
    if (this.cases === null || this.cases === undefined) {
      throw new Error('Required field "cases" is not set');
    }
    const set = EnumMapRule.createSetVector(builder, this.set);
    const cases = EnumMapRule.createCasesVector(
      builder,
      builder.createObjectOffsetList(this.cases),
    );

    return EnumMapRule.createEnumMapRule(
      builder,
      set,
      cases,
      this.otherwise,
      this.otherwiseMember,
      this.emit,
    );
  }

  clone(): EnumMapRuleT {
    const obj = new EnumMapRuleT();
    obj.set = [...this.set];
    obj.cases = this.cases.map((e) => e.clone());
    obj.otherwise = this.otherwise;
    obj.otherwiseMember = this.otherwiseMember;
    obj.emit = this.emit;
    return obj;
  }

  equals(other: EnumMapRuleT): boolean {
    if (this.set.length !== other.set.length) return false;
    for (let i = 0; i < this.set.length; i++) {
      if (this.set[i] !== other.set[i]) return false;
    }
    if (this.cases.length !== other.cases.length) return false;
    for (let i = 0; i < this.cases.length; i++) {
      const a = this.cases[i];
      const b = other.cases[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.otherwise !== other.otherwise) return false;
    if (this.otherwiseMember !== other.otherwiseMember) return false;
    if (this.emit !== other.emit) return false;
    return true;
  }
}

export function verifyEnumMapRule(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVector(pos, 4);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "set");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyCase);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "cases");
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 2);
    verifier.checkScalarField(tablePos, 12, 1);
  } finally {
    verifier.popDepth();
  }
}
